/**
 * Crea una factory que **cachea una instancia por clave** (string). La primera
 * vez para una clave dada construye con `create`; las siguientes retornan la
 * misma instancia. Cada llamada a `createCachedFactory` tiene su propia caché.
 *
 * Uso típico (un servicio por scope):
 * ```ts
 * export const fx_createAplicacionGetListByFincaIdService = createCachedFactory(
 *   (fincaId) => new AplicacionGetListByFincaIdService(fincaId),
 * );
 * ```
 *
 * @param create Construye una instancia a partir de la clave.
 * @returns Factory `(key) => instancia` cacheada por clave.
 */
export function createCachedFactory<T>(
  create: (key: string) => T,
): (key: string) => T {
  const cache = new Map<string, T>();
  return (key) => {
    let instance = cache.get(key);
    if (!instance) {
      instance = create(key);
      cache.set(key, instance);
    }
    return instance;
  };
}
